import React from 'react'

const EtDeleteSponsorUserPad = () => {
  return (
    <div>EtDeleteSponsorUserPad</div>
  )
}

export default EtDeleteSponsorUserPad